import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import { ArtificialIntelligenceIcon, EditIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Link } from 'foundations-components/transitional/components/Link';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { getFullUrl } from 'hubspot-url-utils';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { trackStandaloneEvent } from '../../../usage-tracking/clients/usageTracker';
import { ReplyRecommendationCitationsButton } from './citations/ReplyRecommendationCitationsButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const handleCustomerAgentClick = () => {
  trackStandaloneEvent('Customer Agent Discovery', 'Reply Recs CTA Clicked', {});
  window.open(`${getFullUrl('app')}/customer-agent/${PortalIdParser.get()}`, '_blank');
};
const CustomerAgentLink = ({
  children
}) => {
  return /*#__PURE__*/_jsx(Link, {
    color: "text-core-default",
    underline: true,
    onClick: handleCustomerAgentClick,
    children: children
  });
};
CustomerAgentLink.displayName = 'CustomerAgentLink';
export const ReplyRecommendation = ({
  onEdit,
  onDismiss,
  currentReplyRecommendation
}) => {
  var _currentReplyRecommen;
  return /*#__PURE__*/_jsxs(View, {
    as: "aside",
    role: "status",
    padding: "200",
    margin: "100",
    borderRadius: "200",
    backgroundColor: "fill-accent-magenta-subtle-alt",
    children: [/*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      children: [/*#__PURE__*/_jsxs(Flex, {
        as: "span",
        alignItems: "center",
        gap: "100",
        children: [/*#__PURE__*/_jsx(ArtificialIntelligenceIcon, {}), /*#__PURE__*/_jsx(H2, {
          typography: "heading-50",
          margin: "0",
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "composer-ui.reply-recommendations.title_jsx",
            elements: {
              Link: CustomerAgentLink
            }
          })
        })]
      }), ((_currentReplyRecommen = currentReplyRecommendation.citations) === null || _currentReplyRecommen === void 0 ? void 0 : _currentReplyRecommen.length) > 0 ? /*#__PURE__*/_jsx(ReplyRecommendationCitationsButton, {
        citationsList: currentReplyRecommendation.citations
      }) : null]
    }), /*#__PURE__*/_jsx(ScrollContainer, {
      maxHeight: "58px",
      gradientColor: "fill-accent-magenta-subtle-alt",
      children: /*#__PURE__*/_jsx(Text, {
        typography: "body-100",
        children: /*#__PURE__*/_jsx(SanitizedText, {
          body: currentReplyRecommendation.richText || currentReplyRecommendation.text
        })
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      gap: "200",
      children: [/*#__PURE__*/_jsxs(Button, {
        margin: "0",
        size: "extra-small",
        use: "tertiary",
        onClick: onEdit,
        children: [/*#__PURE__*/_jsx(EditIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "composer-ui.reply-recommendations.edit"
        })]
      }), /*#__PURE__*/_jsx(Button, {
        margin: "0",
        use: "tertiary-light",
        size: "extra-small",
        onClick: onDismiss,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "composer-ui.reply-recommendations.dismiss"
        })
      })]
    })]
  });
};
ReplyRecommendation.displayName = 'ReplyRecommendation';